import SaveTemplateDialog from "../../../../report-lists/templates/SaveTemplateDialog.tsx";
import { useVisualizationContext } from "./context/VisualizationContext";
import type { ReportTemplate } from "../../../../../../../api/types/svTypes.ts";

const SaveTemplateChangesDialog = () => {
  const {
    showSaveDialog,
    report,
    onCloseSaveChanges,
    companies,
    onSaveChangesSaved,
    getCurrentReportConfigurationAsync,
  } = useVisualizationContext();

  if (showSaveDialog && report) {
    return (
      <SaveTemplateDialog
        title="Save Template"
        template={report as ReportTemplate}
        getTemplateConfigurationAsync={getCurrentReportConfigurationAsync}
        onClose={onCloseSaveChanges}
        onSaved={onSaveChangesSaved}
        companies={companies}
      />
    );
  }

  return null;
};

export default SaveTemplateChangesDialog;
